export const PRIMARY_COLOR = '#D41117';

export const FONT_SIZE_BASE = '14px';
